<template>
    <span class="text-muted" v-show="totalRows > 0">
        <slot v-bind="{rangeFrom, rangeTo, totalRows}">
            Displaying {{rangeFrom}} - {{rangeTo}} of {{totalRows}} results
        </slot>
    </span>
</template>
<script>
export default {
    name: 'oc-pagination-summary',
    props: {
        page: {
            type: [String, Number],
            default: 1
        },
        rowsPerPage: {
            type: [String, Number],
            required: true
        },
        totalRows: {
            type: [String, Number],
            required: true
        },
        handler: {
            type: [Object, Boolean],
            default: false,
            validator: function (value) {
                return typeOf(value) === 'boolean' || typeOf(value) === 'Paginator'
            }
        }
    },
    data() {
        let pages = Math.ceil(this.totalRows / this.rowsPerPage)
        let currentPage = parseInt(this.page)

        return {
            pages,
            currentPage
        }
    },
    computed: {
        rangeFrom() {
            return ((parseInt(this.page) - 1) * this.rowsPerPage) + 1
        },
        rangeTo() {
            let rangeTo = this.rangeFrom - 1 + this.rowsPerPage

            if( rangeTo > this.totalRows ) {
                return this.totalRows
            }

            return rangeTo
        }
    }
}
</script>
